module.exports = __webpack_public_path__ + "static/media/testing.1d609eba.png";